export const isEnvDefinedOrThrow = (
  envVar: string | undefined,
  name: string,
) => {
  if (envVar) {
    return true
  }
  if (
    ['local', 'dev', 'development', undefined].includes(
      process.env.NODE_ENV ?? 'toto',
    )
  ) {
    console.warn(`Missing env var ${name}`)
    return false
  }
  throw new Error(`${process.env.NODE_ENV} - missing env var ${name}`)
}
